module.exports = __webpack_public_path__ + "img/glasbreak-sensor-lg-ok.2db6a1c2.svg";